import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import Particle from "../Particle";

function Contact() {
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch("https://formspree.io/f/mldbjwra", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                setStatus("SUCCESS");
                setFormData({ name: "", email: "", message: "" });
            } else {
                setStatus("ERROR");
            }
        } catch (error) {
            setStatus("ERROR");
        }
    };

    return (
        <Container fluid className="Contact-section" style={{ paddingTop: "70px" }}>
            <Container>
                <h1 className="contact-heading text-center mb-5" style={{ fontSize: "2.5rem", color: "#343a40" }}>
                    Get in <strong style={{ color: "#6c63ff" }}>Touch</strong>
                </h1>

                <Row className="justify-content-center">
                    <Col md={10} lg={8}>
                        <div
                            style={{
                                borderRadius: "10px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                padding: "30px",
                                backgroundColor: "transparent",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "1.3rem",
                                    color: "#6c63ff",
                                    marginBottom: "30px",
                                    textAlign: "center",
                                    fontWeight: "500",
                                }}
                            >
                                We'd love to hear from you! Fill out the form below, and we'll get back to you soon.
                            </p>

                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-4" controlId="formName">
                                    <Form.Label style={{ fontWeight: "600", fontSize: "1.2rem", color: "#343a40" }}>
                                        Your Name
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Enter your name"
                                        required
                                        style={{
                                            padding: "12px",
                                            fontSize: "1.1rem",
                                            border: "2px solid #6c63ff",
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4" controlId="formEmail">
                                    <Form.Label style={{ fontWeight: "600", fontSize: "1.2rem", color: "#343a40" }}>
                                        Email address
                                    </Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Enter your email"
                                        required
                                        style={{
                                            padding: "12px",
                                            fontSize: "1.1rem",
                                            border: "2px solid #6c63ff",
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4" controlId="formMessage">
                                    <Form.Label style={{ fontWeight: "600", fontSize: "1.2rem", color: "#343a40" }}>
                                        Message
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Your message"
                                        required
                                        style={{
                                            padding: "12px",
                                            fontSize: "1.1rem",
                                            border: "2px solid #6c63ff",
                                        }}
                                    />
                                </Form.Group>

                                <div className="text-center">
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        style={{
                                            backgroundColor: "#6c63ff",
                                            border: "none",
                                            padding: "12px 35px",
                                            fontSize: "1.2rem",
                                            fontWeight: "600",
                                        }}
                                    >
                                        Send Message
                                    </Button>
                                </div>
                            </Form>

                            {status === "SUCCESS" && (
                                <Alert variant="success" className="mt-4 text-center">
                                    ✅ Message sent successfully!
                                </Alert>
                            )}
                            {status === "ERROR" && (
                                <Alert variant="danger" className="mt-4 text-center">
                                    ❌ Oops! Something went wrong. Please try again.
                                </Alert>
                            )}

                            <Particle />
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Contact;
